<!-- <div class="row">
<div class="col">
  <app-tabs> -->
    <app-tab title="Assigned Parts">
      <div class="row">
        <div class="col">
          <table class='table table-bordered'>
            <thead class='thead-dark'>
              <tr>
                <th>#</th>
                <th>Part</th>
                <th>Model</th>
                <th>Part No.</th>
                <th>Value</th>
                <th>Qty</th>
                <th>Totals</th>
              </tr>
            </thead>
            <tbody>
              @for (row of this.parts; track row) {
                <tr>
                  <td>{{row.id}}</td>
                  <td>{{row.part.name}}</td>
                  <td>{{row.part.model}}</td>
                  <td>{{row.part.manufacturerPartNumber}}</td>
                  <td>£{{row.part.value}}</td>
                  <td>{{row.qty}}</td>
                  <td>£{{row.qty * row.part.value}}</td>
                </tr>
              }
              <tr>
                <td colspan='6'></td>
                <td>£{{this.total}}</td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>
    </app-tab>
    @if (this.allowLink) {
      <app-tab title="Add Parts">
        <div class="row">
          <div class="col">
            @if (this.showSuccess) {
              <div class="alert alert-success">
                Parts have been saved.
              </div>
            }
            @if (this.showDropdown) {
              <ng-select
          [items]="this.partList"
          bindLabel="display"
          [multiple]="true"
          [closeOnSelect]="false"
          [compareWith]="compareById"
          placeholder="Select Parts to Add"
          [(ngModel)]="this.selectedParts">
          <ng-template ng-header-tmp>
            <button type="button" class="btn btn-sm btn-link" (click)="this.selectedParts = this.partList.slice()">Select All</button>
            <button type="button" class="btn btn-sm btn-link" (click)="this.selectedParts = []">UnSelect All</button>
          </ng-template>
        </ng-select>
              <hr>
                @if (this.selectedParts.length > 0) {
                  <button class='btn btn-success' (click)='populateList()'>Add to List</button>
                }
              }
              @if (!this.showDropdown) {
                <table class='table table-bordered'>
                  <thead class='thead-dark'>
                    <tr>
                      <th>Part</th>
                      <th>Qty</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of this.addParts; track row) {
                      <tr>
                        <td>{{row.name}} (£{{row.value}}) - {{row.totalStock - row.addQty}} In Stock</td>
                        <td>
                          <input
                            class='form-control'
                            type='number'
                            [(ngModel)]='row.addQty'
                            [class.is-valid]='row.addQty > 0 && row.addQty <= row.totalStock'
                            [class.is-invalid]='row.addQty <= 0 || row.addQty > row.totalStock'
                            min='1'
                            max='row.totalStock'
                            />
                        </td>
                        <td>£{{row.addQty * row.value}}</td>
                      </tr>
                    }
                    <tr>
                      <td colspan='3'>
                        <button class='btn btn-success' (click)='updateParts()'>Save Parts</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            </div>
          </div>
        </app-tab>
      }
    <!-- </app-tabs>

  </div> -->
<!-- </div> -->
